// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2478":"c0844164","5182":"b3c5eed1","7477":"f4f1345f","9906":"dd13dd2c"}[chunkId] + ".chunk.css";
};